// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".style-chooser-schedule .vs__dropdown-menu{max-width:50vw!important}.style-chooser-schedule .vs__dropdown-menu li{white-space:normal;word-wrap:break-word}", ""]);
// Exports
module.exports = exports;
